import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneoutsttaioninnovacrysta() {



const cardData = {
keyword: "Pune to Outstation Innova Crysta Booking",
headingDescription: "Pune to Outstation Innova Crysta Booking is a convenient option for families, groups, corporate travelers, and tourists planning comfortable private road journeys from Pune. The spacious 7-seater Innova Crysta offers air-conditioned seating, practical luggage capacity, and professional driver support for one-way trips, round trips, weekend holidays, family tours, business travel, and long-distance intercity journeys. Whether the destination is Mumbai, Lonavala, Mahabaleshwar, Nashik, Shirdi, Kolhapur, Goa, or another city, an outstation Innova Crysta provides a flexible way to travel together with convenient pickup and drop arrangements.",
topPlaces: [
{
title: "Mumbai",
description: "Mumbai is a major destination from Pune for business travel, family visits, shopping, events, airport transfers, and leisure trips. An Innova Crysta outstation cab provides spacious private transportation for families and groups carrying luggage, with convenient point-to-point travel between Pune and different parts of Mumbai."
},
{
title: "Lonavala",
description: "Lonavala is a popular weekend destination for travelers from Pune, offering hill views, resorts, lakes, and tourist attractions. An Innova Crysta is suitable for families and groups planning a short outstation trip because it provides comfortable seating, luggage space, and private transportation throughout the journey."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar is a well-known hill station visited for family holidays, weekend breaks, sightseeing, and group tours. A spacious Innova Crysta provides a convenient travel option from Pune, allowing passengers to carry luggage comfortably and travel together while visiting viewpoints, waterfalls, lakes, and nearby attractions."
},
{
title: "Nashik",
description: "Nashik is an important destination for religious visits, tourism, business requirements, and family travel. An Innova Crysta outstation taxi offers useful passenger and luggage space for the longer journey from Pune, making it practical for groups planning one-way or round-trip transportation."
},
{
title: "Shirdi",
description: "Shirdi is a prominent pilgrimage destination visited by families, devotees, and groups throughout the year. Booking an Innova Crysta from Pune provides private door-to-door transportation with spacious seating and luggage capacity, making it convenient for passengers planning both onward and return travel."
},
{
title: "Kolhapur",
description: "Kolhapur attracts visitors for religious tourism, heritage attractions, business travel, and family trips. An Innova Crysta is suitable for the intercity journey from Pune because multiple passengers can travel together in one comfortable vehicle with sufficient room for personal belongings."
},
{
title: "Goa",
description: "Goa is a popular long-distance destination for vacations, family tours, group holidays, and leisure travel from Pune. The Innova Crysta provides an air-conditioned and spacious cabin for extended journeys, making it practical for passengers carrying luggage and traveling together over a longer distance."
},
{
title: "Alibaug",
description: "Alibaug is a popular coastal getaway for families, friends, and weekend travelers from Pune. An Innova Crysta outstation cab provides private transportation with useful luggage space and comfortable seating, allowing passengers to travel directly to their accommodation and nearby attractions."
},
{
title: "Aurangabad",
description: "Aurangabad, officially Chhatrapati Sambhajinagar, is known for heritage attractions, religious destinations, and tourism. An Innova Crysta is a convenient option for families and groups traveling from Pune who want private intercity transportation with adequate space for passengers and luggage."
},
{
title: "Satara",
description: "Satara is a convenient destination from Pune for family visits, regional business travel, tourism, and nature-oriented trips. A 7-seater Innova Crysta can accommodate small groups comfortably while providing private transportation for one-way journeys, round trips, and planned sightseeing travel."
}
],
services: [
{
name: "Pune Outstation Innova Crysta Cab",
description: "Pune Outstation Innova Crysta Cab provides spacious private transportation for travelers heading from Pune to destinations across Maharashtra and neighboring states. The 7-seater cabin, air conditioning, luggage capacity, and driver assistance make it suitable for families, groups, tourists, and corporate travelers."
},
{
name: "Pune Outstation Innova Crysta Taxi",
description: "Pune Outstation Innova Crysta Taxi is designed for passengers seeking comfortable intercity transportation in a private vehicle. It can be arranged for family holidays, business travel, religious journeys, weekend trips, sightseeing tours, and longer road routes from Pune."
},
{
name: "Pune Outstation Innova Crysta Rental",
description: "Pune Outstation Innova Crysta Rental provides flexible access to a spacious vehicle for planned travel beyond Pune. Travelers can use the rental for one-way journeys, round trips, family vacations, group tours, corporate travel, weekend getaways, and multi-day sightseeing itineraries."
},
{
name: "Pune Outstation Innova Crysta Hire",
description: "Pune Outstation Innova Crysta Hire offers a comfortable private vehicle for families, groups, and business travelers planning intercity journeys. With spacious seating and driver support, the service is suitable for holidays, events, religious trips, sightseeing, and long-distance transportation."
},
{
name: "Innova Crysta Outstation Booking Pune",
description: "Innova Crysta Outstation Booking Pune allows travelers to arrange a spacious 7-seater vehicle according to their destination, passenger count, and travel schedule. It can support planned trips to hill stations, cities, pilgrimage destinations, coastal locations, and other outstation routes."
},
{
name: "Innova Crysta on Rent for Outstation Pune",
description: "Innova Crysta on Rent for Outstation Pune is useful for passengers planning private road trips outside the city. The spacious cabin provides comfortable seating for families and groups, while the luggage area helps accommodate travel bags during weekend holidays and longer journeys."
},
{
name: "Innova Crysta Outstation Cab Service Pune",
description: "Innova Crysta Outstation Cab Service Pune provides driver-assisted transportation for travelers going beyond Pune. It is suitable for family tours, corporate journeys, tourist trips, religious travel, weekend getaways, and intercity routes where passengers want a spacious private vehicle."
},
{
name: "AC Innova Crysta Outstation Pune",
description: "AC Innova Crysta Outstation Pune offers a climate-controlled cabin for comfortable travel during extended road journeys. Families, senior travelers, groups, and corporate passengers can benefit from the combination of air-conditioned seating, luggage space, and private transportation."
},
{
name: "Luxury Innova Crysta Outstation Pune",
description: "Luxury Innova Crysta Outstation Pune provides a premium private travel environment for passengers planning special trips, corporate journeys, family vacations, weddings, or tourist travel. Its spacious cabin and comfortable seating make it suitable for longer journeys where a refined travel experience is preferred."
},
{
name: "7 Seater Innova Crysta Outstation Pune",
description: "7 Seater Innova Crysta Outstation Pune is ideal for families and small groups who want to travel together in one spacious vehicle. The additional seating reduces the need for multiple cars, while the luggage area provides useful capacity for bags during longer road journeys."
},
{
name: "One Way Innova Crysta Outstation Pune",
description: "One Way Innova Crysta Outstation Pune provides private transportation for travelers who need to reach an outstation destination without requiring an immediate return journey. It can be useful for relocation, family visits, business travel, airport transfers, and planned intercity trips."
},
{
name: "Round Trip Innova Crysta Outstation Pune",
description: "Round Trip Innova Crysta Outstation Pune is suitable for travelers who need transportation for both the onward and return journeys. Families, tourists, and groups can use the same private vehicle for holidays, religious visits, sightseeing programs, and scheduled outstation travel."
},
{
name: "Family Outstation Innova Crysta Pune",
description: "Family Outstation Innova Crysta Pune provides a comfortable travel solution for families planning holidays, religious trips, weddings, and visits to relatives. The spacious cabin allows family members to stay together while carrying luggage and following a convenient private travel itinerary."
},
{
name: "Group Travel Innova Crysta Pune",
description: "Group Travel Innova Crysta Pune allows friends, relatives, colleagues, and small groups to share one spacious vehicle for their outstation journey. This simplifies travel coordination and provides comfortable seating, luggage capacity, and driver-assisted transportation for the entire group."
},
{
name: "Corporate Outstation Innova Crysta Pune",
description: "Corporate Outstation Innova Crysta Pune is suitable for executives, employees, clients, and business teams traveling between Pune and other cities. It can be used for meetings, conferences, site visits, corporate events, and business tours requiring comfortable group transportation."
},
{
name: "Affordable Innova Crysta Outstation Pune",
description: "Affordable Innova Crysta Outstation Pune offers a practical option for travelers who need additional seating and luggage space for an intercity journey. It can be considered for family trips, group holidays, weekend travel, sightseeing, religious visits, and corporate transportation."
},
{
name: "Innova Crysta for Long Distance Pune",
description: "Innova Crysta for Long Distance Pune provides a spacious travel environment for extended road journeys. Families, groups, and business travelers can benefit from comfortable seating, air conditioning, luggage capacity, and private driver-assisted transportation throughout the trip."
},
{
name: "Innova Crysta Intercity Cab Pune",
description: "Innova Crysta Intercity Cab Pune provides private transportation between Pune and other cities for tourism, business, family visits, and personal travel. The spacious cabin allows multiple passengers to travel together while carrying luggage comfortably on longer routes."
},
{
name: "Innova Crysta Tourist Cab Pune",
description: "Innova Crysta Tourist Cab Pune is suitable for travelers planning sightseeing trips outside Pune. Families and groups can use the vehicle for hill stations, heritage destinations, pilgrimage centers, coastal holidays, and multi-stop tours while enjoying private driver-assisted transportation."
},
{
name: "Innova Crysta Outstation Taxi Near Me Pune",
description: "Innova Crysta Outstation Taxi Near Me Pune is useful for travelers searching for a spacious vehicle close to their pickup location for an intercity trip. The service can support family holidays, group tours, corporate journeys, weekend getaways, and long-distance travel from Pune."
},
{
name: "Private Innova Crysta Outstation Cab Pune",
description: "Private Innova Crysta Outstation Cab Pune provides exclusive vehicle use for families, individuals, and groups traveling outside Pune. Passengers can enjoy greater privacy while traveling together for holidays, business trips, religious journeys, sightseeing programs, and family visits."
},
{
name: "Innova Crysta Outstation Cab with Driver Pune",
description: "Innova Crysta Outstation Cab with Driver Pune provides chauffeur-assisted transportation for passengers planning longer road journeys. A professional driver can manage the route while families, tourists, groups, and corporate travelers focus on their activities and enjoy the spacious cabin."
},
{
name: "Weekend Outstation Innova Crysta Pune",
description: "Weekend Outstation Innova Crysta Pune is convenient for families and friends planning short breaks from Pune. The spacious vehicle provides comfortable seating and luggage capacity for trips to hill stations, coastal destinations, heritage locations, and other popular weekend travel routes."
},
{
name: "Innova Crysta Outstation Car Hire Pune",
description: "Innova Crysta Outstation Car Hire Pune offers a practical private vehicle for travelers planning longer journeys outside Pune. It can be arranged for one-way travel, round trips, family tours, corporate trips, sightseeing programs, and multi-day travel plans."
},
{
name: "Innova Crysta Outstation Rental Service Pune",
description: "Innova Crysta Outstation Rental Service Pune provides flexible transportation for families, groups, tourists, and business travelers. The spacious 7-seater vehicle is suitable for planned intercity travel, weekend holidays, long-distance routes, family tours, and customized sightseeing itineraries."
}
],
tableData: [
["Pune Outstation Innova Crysta Cab"],
["Pune Outstation Innova Crysta Taxi"],
["Pune Outstation Innova Crysta Rental"],
["Pune Outstation Innova Crysta Hire"],
["Innova Crysta Outstation Booking Pune"],
["Innova Crysta on Rent for Outstation Pune"],
["Innova Crysta Outstation Cab Service Pune"],
["AC Innova Crysta Outstation Pune"],
["Luxury Innova Crysta Outstation Pune"],
["7 Seater Innova Crysta Outstation Pune"],
["One Way Innova Crysta Outstation Pune"],
["Round Trip Innova Crysta Outstation Pune"],
["Family Outstation Innova Crysta Pune"],
["Group Travel Innova Crysta Pune"],
["Corporate Outstation Innova Crysta Pune"],
["Affordable Innova Crysta Outstation Pune"],
["Innova Crysta for Long Distance Pune"],
["Innova Crysta Intercity Cab Pune"],
["Innova Crysta Tourist Cab Pune"],
["Innova Crysta Outstation Taxi Near Me Pune"],
["Private Innova Crysta Outstation Cab Pune"],
["Innova Crysta Outstation Cab with Driver Pune"],
["Weekend Outstation Innova Crysta Pune"],
["Innova Crysta Outstation Car Hire Pune"],
["Innova Crysta Outstation Rental Service Pune"]
],
whychoose: [
{
WhyChooseheading: "Spacious 7-Seater Configuration",
WhyChoosedescription: "The Innova Crysta provides practical seating for families and small groups traveling together from Pune. Its spacious cabin helps passengers remain comfortable during longer journeys while the luggage area provides useful room for travel bags and personal belongings."
},
{
WhyChooseheading: "Comfort for Long-Distance Routes",
WhyChoosedescription: "Outstation travel often involves several hours on the road, making cabin comfort an important consideration. The Innova Crysta combines spacious seating, air conditioning, and a practical interior to create a more convenient environment for extended intercity journeys."
},
{
WhyChooseheading: "One-Way and Return Travel",
WhyChoosedescription: "Passengers can plan transportation around their specific itinerary, whether they need only an onward journey or require a vehicle for both directions. This flexibility works well for family visits, holidays, religious travel, business trips, and sightseeing programs."
},
{
WhyChooseheading: "Convenient for Families and Groups",
WhyChoosedescription: "Families, friends, relatives, and colleagues can travel together in one private vehicle instead of arranging multiple cars. This makes it easier to coordinate departure, luggage, stops, sightseeing, and destination transfers throughout the journey."
},
{
WhyChooseheading: "Air-Conditioned Private Travel",
WhyChoosedescription: "An air-conditioned cabin helps maintain a comfortable travel environment during long road journeys. Private vehicle usage also gives passengers the convenience of traveling exclusively with their own group without sharing the cabin with unrelated travelers."
},
{
WhyChooseheading: "Professional Driver Support",
WhyChoosedescription: "Driver-assisted outstation transportation allows passengers to relax or concentrate on their travel activities instead of managing the road journey. This is especially useful for unfamiliar routes, long-distance trips, multi-stop tours, and family holidays."
},
{
WhyChooseheading: "Useful for Weekend Getaways",
WhyChoosedescription: "An Innova Crysta is suitable for short breaks from Pune to destinations such as Lonavala, Mahabaleshwar, Alibaug, and other regional attractions. Families and friends can carry their luggage comfortably while following their preferred departure and return schedule."
},
{
WhyChooseheading: "Practical Luggage Capacity",
WhyChoosedescription: "Outstation trips generally require more luggage than regular city travel, particularly when families are traveling for multiple days. The Innova Crysta offers useful space for travel bags while maintaining comfortable seating for passengers throughout the journey."
}
]
};

















const faqData = [
{
question: "Can I book an Innova Crysta from Pune for an outstation journey?",
answer: "An Innova Crysta can be booked from Pune for outstation travel to cities, hill stations, pilgrimage destinations, and other locations. Citysky Cabs can arrange the journey based on your pickup point, destination, travel date, passenger count, luggage, and preferred trip schedule."
},
{
question: "Which destinations can I travel to from Pune by Innova Crysta?",
answer: "Travellers can plan Innova Crysta journeys from Pune to destinations such as Mumbai, Goa, Nashik, Shirdi, Mahabaleshwar, Kolhapur, Aurangabad, Bangalore, Hyderabad, and other locations. The route can be discussed according to whether the journey is planned as a one-way, return, or multi-day trip."
},
{
question: "Is an Innova Crysta suitable for long-distance outstation travel?",
answer: "For longer journeys, an Innova Crysta can be a convenient choice for families, friends, and small groups who want to travel together. The vehicle is also useful when the itinerary includes luggage, sightseeing stops, overnight stays, or multiple destinations along the route."
},
{
question: "Can I book an Innova Crysta for a family outstation trip from Pune?",
answer: "Family groups can arrange an Innova Crysta for holidays, religious tours, weddings, family visits, and weekend getaways. Travelling in one vehicle allows everyone to follow the same route and schedule while making it easier to manage luggage, children, senior passengers, and planned breaks."
},
{
question: "Can I book a one-way Innova Crysta from Pune to another city?",
answer: "One-way Innova Crysta bookings can be discussed for travellers who need transportation from Pune to another city without requiring the same vehicle for the return journey. During the enquiry, provide the pickup location, destination, travel date, passenger count, and preferred departure time."
},
{
question: "Can I book a round-trip Innova Crysta for outstation travel?",
answer: "A round-trip arrangement can be planned when passengers intend to return to Pune after completing their visit. This can suit holidays, pilgrimage trips, business travel, family functions, and sightseeing programs where the return date and approximate schedule are known in advance."
},
{
question: "Can I hire an Innova Crysta for a multi-day outstation tour?",
answer: "Multi-day Innova Crysta travel can be arranged for extended vacations, group tours, religious circuits, family occasions, and business journeys. Sharing the complete itinerary, overnight destinations, number of travel days, passenger count, and expected stops helps in planning the transportation around the trip."
},
{
question: "Can I carry multiple bags in an Innova Crysta during an outstation trip?",
answer: "Passengers travelling with several suitcases or personal bags can mention their approximate luggage requirements while making the booking enquiry. Providing these details is especially useful for family holidays, weddings, airport-linked journeys, and multi-day tours where luggage volume may be higher."
},
{
question: "Can corporate groups book an Innova Crysta from Pune for outstation travel?",
answer: "Companies can arrange an Innova Crysta for client visits, conferences, business meetings, training programs, industrial visits, employee travel, and team outings outside Pune. The transportation schedule can be coordinated around business appointments, pickup locations, destinations, and the expected duration of the journey."
},
{
question: "How can I book a Pune to Outstation Innova Crysta with Citysky Cabs?",
answer: "To make an Innova Crysta booking, share your Pune pickup location, destination, travel date, passenger count, luggage details, departure time, and whether you require one-way or round-trip transportation. Citysky Cabs can coordinate the cab arrangement according to your outstation itinerary and travel requirements."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Amit Deshpande",
feedback:
"I arranged an Innova Crysta from Pune for a family trip covering multiple destinations. We had several bags and wanted everyone to remain together throughout the journey. Citysky Cabs handled the booking details based on our route and travel dates, which made the transportation planning much simpler for us.",
rating: 5
},
{
id: 2,
name: "Miss. Kavita Joshi",
feedback:
"Our group needed an Innova Crysta for an outstation weekend journey from Pune. We were looking for one vehicle that could accommodate the passengers and luggage while allowing us to follow our planned itinerary. The booking experience with Citysky Cabs was straightforward, and the cab arrangement worked well for our trip.",
rating: 5
}
];


























    const Images = [

    { place: "/images/keyword/1.jpg", text: "Innova Crysta Cab in Pune", link: "innova-crysta-cab-in-pune" },

    { place: "/images/keyword/2.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },

    { place: "/images/keyword/3.jpg", text: "Innova Crysta Cabs / Taxi Booking in Pune", link: "innova-crysta-cabs-taxi-booking-in-pune" },

    { place: "/images/keyword/4.jpg", text: "Pune to Mahabaleshwar Innova Crysta Cab", link: "pune-to-mahabaleshwar-innova-crysta-cab" },

    { place: "/images/keyword/5.jpg", text: "Book Innova Crysta for Outstation From Pune", link: "book-innova-crysta-for-outstation-from-pune" },

    { place: "/images/keyword/6.jpg", text: "Innova Crysta Cabs for Pune Airport", link: "innova-crysta-cabs-for-pune-airport" },

    { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Airport Innova Crysta", link: "pune-to-mumbai-airport-innova-crysta" },

    { place: "/images/keyword/8.jpg", text: "Innova Crysta Cab for Corporate Office", link: "innova-crysta-cab-for-corporate-office" },

    { place: "/images/keyword/9.jpg", text: "Mumbai Airport to Pune Innova Crysta Cabs", link: "mumbai-airport-to-pune-innova-crysta-cabs" },

    { place: "/images/keyword/10.jpg", text: "Pune to Shirdi Innova Crysta", link: "pune-to-shirdi-innova-crysta" },

    { place: "/images/keyword/11.jpg", text: "Pune Aurangabad Innova Crysta Cab Service", link: "pune-aurangabad-innova-crysta-cab-service" },

    { place: "/images/keyword/12.jpg", text: "Pune to Goa Innova Crysta Cab", link: "pune-to-goa-innova-crysta-cab" },

    { place: "/images/keyword/13.jpg", text: "Pune to Bangalore Innova Crysta Cab", link: "pune-to-bangalore-innova-crysta-cab" },

    { place: "/images/keyword/14.jpg", text: "Pune to Hyderabad Innova Crysta Rental Cab", link: "pune-to-hyderabad-innova-crysta-rental-cab" },

    { place: "/images/keyword/15.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-2" },

    { place: "/images/keyword/16.jpg", text: "Pune to Lavasa Innova Crysta Cab Booking", link: "pune-to-lavasa-innova-crysta-cab-booking" },

    { place: "/images/keyword/17.jpg", text: "Pune Darshan Innova Crysta Cabs", link: "pune-darshan-innova-crysta-cabs" },

    { place: "/images/keyword/18.jpg", text: "Innova Crysta Cabs in Pune", link: "innova-crysta-cabs-in-pune" },

    { place: "/images/keyword/19.jpg", text: "Innova Car Rental In Pune", link: "innova-car-rental-in-pune" },

    { place: "/images/keyword/20.jpg", text: "Innova Taxi Service in Pune", link: "innova-taxi-service-in-pune" },

    { place: "/images/keyword/21.jpg", text: "Book Innova for Outstation Pune", link: "book-innova-for-outstation-pune" },

    { place: "/images/keyword/22.jpg", text: "Innova Crysta On Rent In Pune", link: "innova-crysta-on-rent-in-pune-3" },

    { place: "/images/keyword/23.jpg", text: "Pune to Mahabaleshwar Panchgani Innova Crysta Cabs", link: "pune-to-mahabaleshwar-panchgani-innova-crysta-cabs" },

    { place: "/images/keyword/24.jpg", text: "Pune to Outstation Innova Crysta Booking", link: "pune-to-outstation-innova-crysta-booking" },

    { place: "/images/keyword/25.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-4" },


];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Outstation Innova Crysta Booking",
  "image": "https://www.cityskycab.in/assets/images/pune-to-outstation-innova-crysta-booking.webp",
  "description": "Pune to Outstation Innova Crysta Booking from Citysky Cabs is suitable for families, groups, corporate travellers and anyone planning comfortable long-distance road journeys from Pune. The service includes Pune Outstation Innova Crysta Cab, taxi, rental and hire options, along with Innova Crysta on Rent for Outstation travel. The spacious AC vehicle provides comfortable seating and practical luggage capacity for longer highway journeys across Maharashtra and other destinations. Customers can arrange one-way trips, round trips, multi-day travel and destination-specific journeys with convenient Pune pickup and experienced drivers familiar with intercity routes.",
  "brand": {
    "@type": "Brand",
    "name": "Citysky Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.cityskycab.in/pune-to-outstation-innova-crysta-booking"
  }
};





    return (
        <div>

<Helmet>
  <title>
    Pune to Outstation Innova Crysta Booking | Innova Crysta Outstation Hire from Pune | +91 8554819191
  </title>

  <meta
    name="description"
    content="Plan your outstation journey from Pune with an Innova Crysta from Citysky Cabs. Spacious AC seating, experienced drivers and flexible one-way, round-trip and multi-day travel options."
  />

  <meta
    name="keywords"
    content="Pune Outstation Innova Crysta Cab, Pune Outstation Innova Crysta Taxi, Pune Outstation Innova Crysta Rental, Pune Outstation Innova Crysta Hire, Innova Crysta Outstation Booking Pune, Innova Crysta on Rent for Outstation, Pune to Outstation Innova Crysta Booking, Innova Crysta Outstation Cab Pune, Innova Crysta Outstation Taxi Pune, Innova Crysta Outstation Rental Pune, Innova Crysta Outstation Car Pune, Innova Crysta for Outstation Pune, AC Innova Crysta Outstation Pune, 7 Seater Innova Crysta Outstation Pune, Innova Crysta One Way Outstation Pune, Innova Crysta Round Trip Pune, Innova Crysta Long Distance Cab Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div className="sisf-banner sis-br-radius mt-3 position-relative">
                <div className="banner-img">
                    <figure>
                      {/* <img
                            src="/images/page-banner.jpg"
                            alt="Mauliwala Travels Urbania and Mini Bus Rental Pune"
                        /> */}
                    </figure>
                </div>

                <div className="sisf-page-title sisf-m sisf-title--standard sisf-alignment--center">
                    <div className="sisf-m-inner container">
                        <div className="sisf-m-content sisf-content-grid">
                            <h1 className="sisf-m-title text-white sis-text-anime-style-3 entry-title">
                                {cardData.keyword}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>














            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/24.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Citysky Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Citysky Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Citysky Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918554819191" className="pc-call">+91 8554819191 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+918459883515" className="pc-call">+91 8459883515 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918459883515
"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918459883515" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@cityskycab.in" className="pc-email">
                                            booking@cityskycab.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Citysky Cabs</strong><br />

                                            Office No,307,3rd Floor,
                                            52, Sinhgad Rd, Wadgaon Budruk,
                                            Narhe, Pune, Maharashtra,India- 411041.






                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Puneoutsttaioninnovacrysta;